import { render, staticRenderFns } from "./WheelBattleConsumerRankTab.vue?vue&type=template&id=9a8b9c4a&scoped=true&"
import script from "./WheelBattleConsumerRankTab.vue?vue&type=script&lang=js&"
export * from "./WheelBattleConsumerRankTab.vue?vue&type=script&lang=js&"
import style0 from "./WheelBattleConsumerRankTab.vue?vue&type=style&index=0&id=9a8b9c4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8b9c4a",
  null
  
)

export default component.exports